<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

withDefaults(defineProps<{
	showToggle?: boolean;
}>(), {
	showToggle: true,
});

const direction = defineModel<'asc' | 'desc'>('direction', { required: true });

const { t } = useI18n();

const directionLabel = computed(() =>
	direction.value === 'asc' ? t('listing.views.sort_ascending') : t('listing.views.sort_descending'),
);

function toggleDirection() {
	direction.value = direction.value === 'desc' ? 'asc' : 'desc';
}
</script>

<template>
	<DFormField :label="$t('listing.views.sorting')">
		<DFieldGroup>
			<slot name="field-select" />
			<DTooltip
				v-if="showToggle"
				:text="directionLabel"
			>
				<DButton
					size="sm"
					variant="outline"
					color="neutral"
					icon="material-symbols:sort-rounded"
					class="px-2"
					:ui="{ leadingIcon: direction === 'desc' ? '' : '-scale-y-100' }"
					:aria-label="directionLabel"
					@click="toggleDirection"
				/>
			</DTooltip>
		</DFieldGroup>
	</DFormField>
</template>
